import React from 'react';
import { Box } from '@mui/material';
import type { TimelineDay } from '../types';
import HeatmapDayColumn from './HeatmapDayColumn';

interface HeatmapGridColumnsProps {
  days: TimelineDay[];
  fillHeight?: boolean;
  hasTopBorder?: boolean;
  hasBottomBorder?: boolean;
}

const HeatmapGridColumns: React.FC<HeatmapGridColumnsProps> = ({ days, hasTopBorder, hasBottomBorder }) => (
  <Box
    component="span"
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      gap: '1px',
      pointerEvents: 'none',
    }}
  >
    {days.map(day => (
      <HeatmapDayColumn key={day.date} height="100%" topBorder={hasTopBorder} hasBottomBorder={hasBottomBorder} />
    ))}
  </Box>
);

export default React.memo(HeatmapGridColumns);
